import React from 'react';
import { IProductPermission } from '../../../redux/duck/productsPage/profileAuth';
import { PATHS } from '../../../routes';
import ProductCard from '../components/ProductCard';
import Wrapper from '../components/Wrapper';
import { IReturnProductIfAvailable } from './interface';

export function isActive(id: number, profileAuthContext: IProductPermission) {
  let active = false;
  profileAuthContext.authorizedProducts.map((product: any) => {
    if (product.id_sistema === id) {
      active = true;
    }
    return active;
  });
  return active;
}

export function goTo(id: number, propsIsActive: boolean, history: any) {
  if (id === 1 && propsIsActive === true) {
    return () => history.push(PATHS.legado);
  }
  return null;
}

export function ReturnProductIfAvailable(props: IReturnProductIfAvailable) {
  let component = <></>;
  if (props.productsContext.products !== []) {
    component = (
      <Wrapper.Cards>
        {props.productsContext.products.map((prod) => (
          <ProductCard
            key={prod.id}
            active={isActive(prod.id, props.profileAuthContext)}
            onClick={goTo(
              prod.id,
              isActive(prod.id, props.profileAuthContext),
              props.history
            )}>
            {prod.nome_sistema}
          </ProductCard>
        ))}
      </Wrapper.Cards>
    );
  } else {
    component = (
      <Wrapper.Cards>
        <h1> ERROR </h1>
      </Wrapper.Cards>
    );
  }

  return component;
}
